import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { trackInitiateCheckout } from "@/lib/fbpixel";
import { usePricing } from "@/lib/pricing";
import { ArrowRight } from "lucide-react";

export default function StickyCTA() {
  const [show, setShow] = useState(false);
  const { checkoutUrl, priceLabel, founding } = usePricing();

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.9);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [setShow]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-50 border-t border-cognac/30 bg-espresso/95 px-4 py-3 backdrop-blur-md md:hidden"
          data-testid="sticky-cta-bar"
        >
          <a
            href={checkoutUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackInitiateCheckout}
            data-testid="sticky-cta-button"
            className="flex w-full items-center justify-between rounded-full bg-cognac-2 px-6 py-3.5 font-heading text-sm font-600 uppercase tracking-[0.16em] text-gold"
            style={{ fontWeight: 600 }}
          >
            <span>{founding ? `Let's Play · ${priceLabel}` : "Let's Play"}</span>
            <ArrowRight className="h-4 w-4" />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
